export default {
  state: {
    data: {},
    product: {},
    loading: false,
    shop_sidebar_loaded: false
  },
  mutations: {
    SET_DATA (state, page) {
      state.data = page;
    },
    SET_PRODUCT (state, product) {
      state.product = product;
    },
    SET_LOADING (state, bool) {
      state.loading = bool;
    },
    SET_SHOP_SIDEBAR_LOADED (state) {
      state.shop_sidebar_loaded = true;
    }
  },
  actions: {
    fetchPage ({
      commit,
      state
    }, page) {
      commit('SET_DATA', page);
    },
    fetchLoading ({
      commit
    }, bool) {
      commit('SET_LOADING', bool);
    },
    fetchShopFiltersLoaded ({
      commit
    }, bool) {
      commit('SET_SHOP_SIDEBAR_LOADED');
    },
    fetchProduct ({
      commit,
      getters
    }, id) {
      let product = getters.getProduct(id);
      console.log(product);
      commit('SET_PRODUCT', product);
    }
  },
  getters: {
    // eslint-disable-next-line camelcase
    getProduct: state => item_id => {
      return state.products.find(item => item.id === item_id);
    }
  }
};
